import { create } from 'zustand'

// Standalone store (kept out of the big app store) for the mobile
// shell's slide-in drawers. Only one drawer is open at a time so the
// canvas keeps as much room as possible on a phone.

export type MobileDrawer = 'models' | 'properties' | null

interface MobileUiState {
  openDrawer: MobileDrawer
  setDrawer: (d: MobileDrawer) => void
  toggleDrawer: (d: Exclude<MobileDrawer, null>) => void
  closeDrawer: () => void
}

export const useMobileUi = create<MobileUiState>((set) => ({
  openDrawer: null,
  setDrawer: (d) => set({ openDrawer: d }),
  toggleDrawer: (d) =>
    set((s) => ({ openDrawer: s.openDrawer === d ? null : d })),
  closeDrawer: () => set({ openDrawer: null }),
}))
